module.exports = __webpack_public_path__ + "img/Virtual_Store.a6829eb2.png";